import { QuoteEditor } from "./QuoteEditor";

export function NewQuote() {
  return (
    <>
      <h1>Nueva cotización</h1>
      <QuoteEditor />
    </>
  );
}
